import AuthChecker from '@/components/AuthChecker';
import LoginOTPToggle from '@/components/Toggle/LoginOTPToggle';
import Register from '@/containers/Register';
import Custom404 from '../404';

const RegisterPage = () => {
  return <LoginOTPToggle v1Component={<AuthChecker><Register /></AuthChecker>} v2Component={<Custom404 />} />
}

export default RegisterPage;
